module.exports = __webpack_public_path__ + "img/44.7199c091.png";